<template>
  <section>
      <headerv></headerv>
      <bodyv></bodyv>
      <footerv></footerv>
  </section>
</template>

<script>
import footerv from '../components/FooterV.vue';
import headerv from '../components/HeaderV.vue';
import bodyv from '../components/BodyV.vue';

export default {
  components: { footerv , headerv , bodyv},

}
</script>
